import { Injectable, computed, signal, type DestroyRef } from '@angular/core';

export type HeaderSearchContext = {
  id: string;
  label: string;
  placeholder: string;
  value: () => string;
  setValue: (value: string) => void;
  clear?: () => void;
};

@Injectable({ providedIn: 'root' })
export class HeaderSearchService {
  private readonly activeContext = signal<HeaderSearchContext | null>(null);

  readonly context = this.activeContext.asReadonly();
  readonly value = computed(() => this.activeContext()?.value() ?? '');

  register(context: HeaderSearchContext, destroyRef: DestroyRef): void {
    this.activeContext.set(context);
    destroyRef.onDestroy(() => {
      if (this.activeContext()?.id === context.id) {
        this.activeContext.set(null);
      }
    });
  }

  setValue(value: string): void {
    this.activeContext()?.setValue(value);
  }

  clear(): void {
    const context = this.activeContext();
    if (!context) return;

    if (context.clear) {
      context.clear();
      return;
    }

    context.setValue('');
  }
}
